import styled, { css } from "styled-components";
import { device } from "../../../constants";

export const DropdownContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
  ${({ isOpen }) =>
		isOpen &&
		css`
      margin-bottom: -16px;
  `}
  
  @media ${device.tablet} {  
    ${({ isOpen }) =>
			isOpen &&
			css`
        margin-bottom: 0px;
    `}
  }

  @media ${device.laptop} {  
    gap: 4px !important;
    flex-direction: row;
  }
`;

export const DropdownButton = styled.button`
  color: ${({ open, theme }) => (open ? theme.colors["vivid-02"] : theme.colors["neutral-01"])};
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.7px;
  text-align: left;
  cursor: pointer;
  background: none;
  border: none;
  display: flex;
  align-items: center;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  padding: 0 16px;

  @media ${device.tablet} {
    font-size: 12px;
    padding: 0;
  }
  
  @media ${device.laptop} {
    font-size: 14px;
  }

  &:hover {
    color: ${({ theme }) => theme.colors["neutral-08"]};

    svg path {
      fill: ${({ theme }) => theme.colors["neutral-08"]};
    }

    &:is([data-theme="dark"] &) {
      color: ${({ theme }) => theme.colors["vivid-02"]};

      svg path {
        fill: ${({ theme }) => theme.colors["vivid-02"]};
      }
    }
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors["vivid-02"]};
    outline-offset: 2px;
  }

  svg {
    margin-left: 12px;
    margin-top: -2px;
    transition: transform 100ms ease-in-out;
    transform: ${({ open }) => (open ? "rotate(180deg)" : "rotate(0deg)")};
  }

  svg path {
    fill: ${({ open, theme }) => (open ? theme.colors["vivid-02"] : theme.colors["neutral-01"])};
  }
  transition: all 100ms ease-in-out;

  ${({ open }) =>
		open &&
		css`
    background-color: ${({ theme }) => theme.colors["neutral-03"]};
    padding: 16px;

    &:is([data-theme="dark"] &) {
      background-color: ${({ theme }) => theme.colors["neutral-06"]};
    }
    
    @media ${device.tablet} {
      background-color: transparent!important;
    }
  `}
`;

export const DropdownMenu = styled.div`
  top: calc(100% + 8px);
  left: 0;
  background-color: ${({ theme }) => theme.colors["background-02"]};
  border-radius: 8px;
  border: 0px;
  transition: all 100ms ease-in-out;
  width: 100%;
  z-index: 1000;
  padding: 16px;
  
  ${({ open }) =>
		!open &&
		css`
      height: 0;
      padding: 0;
  `}

  opacity: ${({ open }) => (open ? 1 : 0)};
  visibility: ${({ open }) => (open ? "visible" : "hidden")};
  transform: ${({ open }) => (open ? "translateY(0)" : "translateY(-10px)")};
  
  & > * + * {
    margin-top: 8px;
  }
  
  @media ${device.laptop} {
    padding: 8px;
    
    & > * + * {
      margin-top: 16px;
    }

    padding: 24px 32px;
    position: absolute;
    min-width: 200px;
    width: fit-content;
    box-shadow: 0px 10px 10px 0px #0000000A, 0px 20px 25px 0px #0000001A;
  }
`;
